import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { AngularSplitModule } from 'angular-split';
import { ComponentsModule } from '../../components/components.module';
import { HoleGroupSchemaRendererComponent } from './hole-group-schema-renderer.component';

@NgModule({
  imports: [AngularSplitModule, FuseSharedModule, ComponentsModule],
  declarations: [HoleGroupSchemaRendererComponent],
  exports: [HoleGroupSchemaRendererComponent],
})
export class HoleGroupSchemaRendererModule {}
